import { ApiError } from 'api/generated';

export type QueryError = ApiError;

export function formatErrorMessage(error: QueryError) {
  const message = error?.body?.error?.message ?? 'Something went wrong';
  return parseJsonSafely(message);
}

function parseJsonSafely(str) {
  try {
    const parsed = JSON.parse(str);

    if (typeof parsed === 'object' && parsed !== null && (parsed.message || parsed.errorMessage || parsed.error)) {
      return parsed.message ?? parsed.errorMessage ?? parsed.error;
    }

    return str;
  } catch {
    return str;
  }
}

export enum Gender {
  Female = 1,
  Male = 2
}
export enum MaritalStatus {
  Unknown = 0,
  Divorced = 1,
  MarriedOrCivilPartnership = 2,
  Single = 3,
  Separated = 4,
  Cohabiting = 5,
  Widowed = 6
}
export enum Role {
  Administrator = 1,
  Accountant = 2,
  BdcAdvisor = 3,
  BodyshopManager = 4,
  PartsDriver = 5,
  PartsManager = 6,
  SalesAdministrator = 7,
  SalesConsultant = 8,
  SalesManager = 9,
  ServiceAdvisor = 10,
  ServiceDriver = 11,
  ServiceManager = 12,
  SiteCoordinator = 13,
  Valetor = 14,
  Technician = 15,
  CarBuyer = 16,
  BodyshopOperative = 17,
  Marketing = 18
}
export enum Status {
  Active = 1,
  Blocked = 2,
  Deleted = 3
}
export enum WorkType {
  FirstJob = 0,
  TheOnlyJob = 1,
  SecondJob = 2
}

export enum HolidayScheduleType {
  Time,
  Sick,
  Training,
  Unpaid,
  BankHoliday,
  Holiday,
  HolidayPending
}

export enum HolidayRequestsStatus {
  Pending = 1,
  Rejected,
  Approved,
  Canceled
}

export enum AttendanceDateType {
  AllDay = 0,
  HalfDate = 1
}

export enum UserStatus {
  Undefined = 0,
  Active = 1,
  Blocked = 2,
  Deleted = 3
}

export enum Page {
  AttendanceLog = 81,
  ApproverSetUp = 82,
  ApprovalsRequests = 83,
  HolidayRequests = 84,
  Employees = 85,
  Candidates = 86,
  MaintenanceTasks = 87,
  SalesExecutors = 88,
  Apprenticeship = 89,
  BranchKPI = 90,
  WorkPattern = 91,
  AppointmentLog = 92,
  VehicleAccidentLog = 93,
  TeamDiary = 94,
  RolesConfiguration = 95,
  EnquiryManagement = 96,
  FrequentlyAskingQuestion = 97,
  Appraisal = 99,
  BranchReferences = 100,
  DocumentsLog = 101,
  Leads = 105,
  PerformanceReview = 106,
  VideoLog = 107,
  TestDriveLog = 108,
  AISettings = 109,
  WebSiteUrl = 110,
  VehicleStock = 111,
  UploadGrossPayPreSacrifice = 112,
  PrintersOverview = 113,
  // RiskAssessment = 113,
  ServicePrices = 114,
  SalesOfferList = 115,
  EventsAndOffers = 118,
  SalesBranchKPIs = 119,
  VehicleInspection = 120,
  WorkshopPlanner = 121,
  TechnicianEfficiencyReport = 122,
  ServiceAdvisors = 123,
  VHCRecords = 124,
  WorkingHours = 125,
  TechnicianUtilizationTime = 126,
  WorkshopCheckInLog = 127,
  PreparationCheck = 128,
  CollectionAndDelivery = 130,
  Blog = 131,
  TrafficSource = 132,
  NewVehicleSettings = 133,
  DigitalWip = 134,
  WorkshopLog = 135,
  ServiceBookingLog = 135
}

export type JobTitlesModel = any;
